module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAfBAMAAADtgAsKAAAAAXNSR0IB2cksfwAAACdQTFRFAAAAKSk9JilAJipAJipAJipBJipAJStAJipAJio/JipAJipAJipAgFIazQAAAA10Uk5TABlQ/9+S0GCw8c6A6MBSpPMAAABKSURBVHicYxBSQgECDMrGKECBZgJGSiqmYDthAgYMbOYMIEC8gEVHp1UHCOC0xXr3HovdIECBLRhmYNiC4Q4ybMEIDzpEA3rsAwBFCFuMYEGj4wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/list-square.png
// module id = uevX
// module chunks = 1